/**
 * MISTER BARREL — Producto Premium V2
 * product-premium-v2.js | ES6+ | Sin jQuery | Shopify OS 2.0
 */

(function () {
  'use strict';

  /* ── Utilidades ─────────────────────────────────────── */
  const qs  = (s, c) => (c || document).querySelector(s);
  const qsa = (s, c) => [...(c || document).querySelectorAll(s)];

  function showToast(msg, type) {
    let t = qs('#Ppv2Toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'Ppv2Toast';
      t.className = 'ppv2-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.className = `ppv2-toast ppv2-toast--${type || 'ok'}`;
    t.classList.add('is-visible');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('is-visible'), 3500);
  }

  /* ================================================================
     AJAX CART
  ================================================================ */
  /* ================================================================
     CART HELPERS — Implementación correcta con Sections API de Dawn
     Dawn's renderContents() necesita la respuesta de /cart/add.js
     que incluya las secciones pre-renderizadas por Shopify.
     Se logra añadiendo sections + sections_url al POST de cart/add.
  ================================================================ */

  /**
   * Obtiene el elemento cart-drawer o cart-notification activo en el DOM.
   */
  function getCartEl() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /**
   * Devuelve los IDs de sección que Dawn necesita para re-renderizar el drawer.
   * cart-drawer.getSectionsToRender() → [{id:'cart-drawer'}, {id:'cart-icon-bubble'}]
   */
  function getDawnSectionIds() {
    const el = getCartEl();
    if (el && typeof el.getSectionsToRender === 'function') {
      return el.getSectionsToRender().map(s => s.id);
    }
    // Fallback si el método no existe
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /**
   * Hace POST a /cart/add.js con sections pre-renderizadas.
   * La respuesta incluye parsedState.sections que Dawn usa en renderContents().
   */
  function cartAddWithSections(variantId, qty) {
    const sectionIds = getDawnSectionIds();
    const quantity   = parseInt(qty, 10) || 1;   // siempre entero, nunca string
    const formData   = new FormData();
    formData.append('id',           variantId);
    formData.append('quantity',     quantity);
    formData.append('sections',     sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);

    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body:    formData
    }).then(r => r.json());
  }

  /**
   * Abre el drawer y lo re-renderiza con el producto recién agregado.
   * parsedState = respuesta completa de /cart/add.js (con .sections)
   */
  function openDrawerWithState(parsedState) {
    const el = getCartEl();
    if (!el) {
      // Último fallback: navegar al carrito
      window.location = window.routes?.cart_url || '/cart';
      return;
    }

    // Quitar clase is-empty si la tiene
    el.classList.remove('is-empty');
    const inner = el.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    // renderContents espera el parsedState con sections
    if (typeof el.renderContents === 'function') {
      el.renderContents(parsedState);
    } else {
      // Fallback: abrir y forzar re-render vía sección
      if (typeof el.open === 'function') el.open();
    }
  }

  /**
   * addToCart — función principal usada por los botones del producto
   */
  function addToCart(variantId, qty, btn) {
    if (!variantId) { showToast('Selecciona una opción primero', 'err'); return; }
    if (btn) btn.classList.add('ppv2-btn--loading');

    cartAddWithSections(variantId, qty)
      .then(data => {
        if (data.status) {
          showToast(data.description || 'Error al agregar', 'err');
        } else {
          showToast('¡Producto agregado al carrito!', 'ok');
          openDrawerWithState(data);
        }
      })
      .catch(() => showToast('Error de conexión', 'err'))
      .finally(() => { if (btn) btn.classList.remove('ppv2-btn--loading'); });
  }

  /**
   * addToCartRelated — función para los botones de productos relacionados
   */
  function addToCartRelated(variantId, qty, btn, addedClass) {
    if (!variantId) { showToast('Selecciona una opción', 'err'); return; }
    if (btn) btn.classList.add(addedClass + '--loading');

    cartAddWithSections(variantId, qty)
      .then(data => {
        if (data.status) {
          showToast(data.description || 'Error al agregar', 'err');
        } else {
          if (btn) btn.classList.add(addedClass + '--added');
          showToast('¡Producto agregado!', 'ok');
          setTimeout(() => btn && btn.classList.remove(addedClass + '--added'), 2200);
          openDrawerWithState(data);
        }
      })
      .catch(() => showToast('Error de conexión', 'err'))
      .finally(() => { if (btn) btn.classList.remove(addedClass + '--loading'); });
  }

  function buyNow(variantId, qty, btn) {
    if (!variantId) { showToast('Selecciona una opción primero', 'err'); return; }
    if (btn) btn.classList.add('ppv2-btn--loading');

    // Limpiar carrito primero, luego agregar y redirigir a checkout
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(qty, 10) || 1 })
      }))
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          showToast(data.description || 'Error al procesar', 'err');
          if (btn) btn.classList.remove('ppv2-btn--loading');
        } else {
          window.location = '/checkout';
        }
      })
      .catch(() => {
        showToast('Error de conexión', 'err');
        if (btn) btn.classList.remove('ppv2-btn--loading');
      });
  }

  /* ================================================================
     GALERÍA PREMIUM — IntersectionObserver + scroll sincronizado
  ================================================================ */
  function initGallery(container) {
    const thumbsWrap = qs('.ppv2-gallery__thumbs', container);
    const thumbs     = qsa('.ppv2-gallery__thumb', container);
    const items      = qsa('.ppv2-gallery__item',  container);

    if (!items.length) return null;

    let currentIdx     = 0;
    let scrollLock     = false; // previene loop scroll→observer→scroll
    let scrollLockTimer = null;

    // Detectar si estamos dentro del Quick View modal
    const isInQuickView = !!container.closest('#cpd-quickview-modal, .cpd-qv__product');

    /* ── Datos de cada media ────────────────────────────── */
    const mediaData = items.map(item => ({
      type  : item.dataset.type   || 'image',
      src   : item.dataset.src    || '',
      video : item.dataset.video  || '',
      embed : item.dataset.embed  || '',   // YouTube/Vimeo URL
      alt   : item.dataset.alt    || ''
    }));

    /* ── Activar item por índice ────────────────────────── */
    function activate(idx, fromScroll) {
      idx = Math.max(0, Math.min(idx, items.length - 1));
      if (idx === currentIdx && fromScroll) return;
      currentIdx = idx;

      // En Quick View o mobile: carousel puro (mostrar/ocultar sin scroll)
      const useCarousel = isInQuickView || isMobile();

      // Actualizar clases en items
      items.forEach((el, i) => {
        el.classList.toggle('is-active', i === idx);
        if (useCarousel) {
          el.style.display = i === idx ? 'block' : 'none';
        } else {
          el.style.display = ''; // dejar que el CSS de desktop maneje el display
        }
      });

      // Actualizar miniaturas
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
      });

      // Scroll suave de la columna de miniaturas para mostrar la activa
      if (thumbsWrap && thumbs[idx]) {
        const thumb = thumbs[idx];
        const wTop  = thumbsWrap.scrollTop;
        const wH    = thumbsWrap.clientHeight;
        const tTop  = thumb.offsetTop;
        const tH    = thumb.offsetHeight;
        if (tTop < wTop || tTop + tH > wTop + wH) {
          thumbsWrap.scrollTo({ top: tTop - wH / 2 + tH / 2, behavior: 'smooth' });
        }
      }

      // Si el click vino de una miniatura → scroll al item (solo en desktop normal, no en QV)
      if (!fromScroll && !useCarousel) {
        scrollLock = true;
        clearTimeout(scrollLockTimer);
        items[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
        scrollLockTimer = setTimeout(() => { scrollLock = false; }, 750);
      }
    }

    /* ── IntersectionObserver: scroll → miniatura ───────── */
    const isMobile = () => window.innerWidth <= 989;

    // En Quick View no usamos IntersectionObserver (el scroll es del modal, no el viewport)
    const obs = isInQuickView ? null : new IntersectionObserver(entries => {
      if (scrollLock) return;
      // Tomar el entry más visible
      let best = null, bestRatio = 0;
      entries.forEach(e => {
        if (e.intersectionRatio > bestRatio) {
          bestRatio = e.intersectionRatio;
          best = e;
        }
      });
      if (best && best.isIntersecting) {
        const idx = parseInt(best.target.dataset.galleryIdx || '0', 10);
        activate(idx, true);
      }
    }, {
      root       : null,
      rootMargin : '-20% 0px -20% 0px', // zona central del viewport
      threshold  : [0, 0.25, 0.5, 0.75, 1]
    });

    items.forEach((item, i) => {
      item.dataset.galleryIdx = i;
      if (obs && !isMobile()) obs.observe(item);
    });

    // Re-conectar/desconectar observer al cambiar tamaño (solo fuera de Quick View)
    let resizeTimer;
    if (!isInQuickView) window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!obs) return;
        items.forEach(item => obs.unobserve(item));
        if (!isMobile()) {
          // Desktop: limpiar inline styles y dejar que CSS controle
          items.forEach(el => { el.style.display = ''; });
          items.forEach(item => obs.observe(item));
        } else {
          // Mobile: re-aplicar inline styles según item activo
          items.forEach((el, i) => { el.style.display = i === currentIdx ? 'block' : 'none'; });
        }
      }, 200);
    });

    /* ── Click en miniaturas ─────────────────────────────── */
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => activate(i, false));
      thumb.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(i, false); }
      });
    });

    /* ── Swipe táctil en mobile (sobre el item activo) ──── */
    let touchStartX = 0, touchStartY = 0;
    container.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    container.addEventListener('touchend', e => {
      if (!isMobile()) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (Math.abs(dx) > 44 && dy < 60) activate(currentIdx + (dx < 0 ? 1 : -1), false);
    });

    /* ── Play de video al hacer clic en overlay ─────────── */
    items.forEach((item, i) => {
      const overlay = qs('.ppv2-gallery__play-overlay', item);
      if (!overlay) return;
      overlay.addEventListener('click', () => {
        const vid    = qs('.ppv2-gallery__item-video',  item);
        const iframe = qs('.ppv2-gallery__item-iframe', item);
        if (vid) {
          vid.classList.add('is-active');
          overlay.style.display = 'none';
          vid.play?.();
        } else if (iframe) {
          // Construir URL embed correcta
          const embedId = iframe.dataset.embedId || '';
          const host    = (iframe.dataset.host || '').toLowerCase();
          let url = '';
          if (host === 'youtube') {
            url = `https://www.youtube.com/embed/${embedId}?autoplay=1&rel=0`;
          } else if (host === 'vimeo') {
            url = `https://player.vimeo.com/video/${embedId}?autoplay=1`;
          } else {
            url = iframe.dataset.embedSrc || '';
          }
          if (url) {
            iframe.src = url;
            iframe.classList.add('is-active');
            overlay.style.display = 'none';
          }
        }
      });
    });

    activate(0, true);

    // En mobile: asegurar que solo el primer item tenga display:block al inicio
    if (isMobile()) {
      items.forEach((el, i) => { el.style.display = i === 0 ? 'block' : 'none'; });
    }

    return {
      activate,
      getMediaData : () => mediaData,
      getCurrentIdx: () => currentIdx,
      isMobile     : isMobile
    };
  }

  /* ================================================================
     LIGHTBOX PREMIUM — Zoom, flechas, swipe, tira de miniaturas
  ================================================================ */
  function initLightbox() {
    let lb = qs('#Ppv2Lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.id        = 'Ppv2Lightbox';
      lb.className = 'ppv2-lightbox';
      lb.setAttribute('role',       'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Visor de imágenes');
      lb.innerHTML = `
        <button class="ppv2-lightbox__close" aria-label="Cerrar visor">
          <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <button class="ppv2-lightbox__nav ppv2-lightbox__nav--prev" aria-label="Imagen anterior">
          <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div class="ppv2-lightbox__media-wrap">
          <img class="ppv2-lightbox__img" src="" alt="" draggable="false"/>
          <video class="ppv2-lightbox__video" controls playsinline></video>
          <iframe class="ppv2-lightbox__iframe" allowfullscreen></iframe>
        </div>
        <button class="ppv2-lightbox__nav ppv2-lightbox__nav--next" aria-label="Imagen siguiente">
          <svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg>
        </button>
        <div class="ppv2-lightbox__strip"></div>
        <div class="ppv2-lightbox__counter"></div>`;
      document.body.appendChild(lb);
    }

    let mediaList = [], idx = 0;
    let zoomed    = false;
    let touchX    = 0;

    const lbImg    = qs('.ppv2-lightbox__img',         lb);
    const lbVid    = qs('.ppv2-lightbox__video',        lb);
    const lbIframe = qs('.ppv2-lightbox__iframe',       lb);
    const closeB   = qs('.ppv2-lightbox__close',        lb);
    const prevB    = qs('.ppv2-lightbox__nav--prev',    lb);
    const nextB    = qs('.ppv2-lightbox__nav--next',    lb);
    const strip    = qs('.ppv2-lightbox__strip',        lb);
    const counter  = qs('.ppv2-lightbox__counter',      lb);

    function showMedia(i) {
      idx = ((i % mediaList.length) + mediaList.length) % mediaList.length;
      const m = mediaList[idx];
      // Reset
      lbImg.classList.remove('is-zoomed'); zoomed = false;
      lbImg.className    = 'ppv2-lightbox__img';
      lbVid.className    = 'ppv2-lightbox__video';
      lbIframe.className = 'ppv2-lightbox__iframe';
      lbVid.pause?.(); lbVid.src = '';
      lbIframe.src = '';

      if (m.type === 'video' && m.video) {
        lbVid.src = m.video;
        lbVid.classList.add('is-active');
      } else if (m.type === 'embed' && m.embed) {
        // Convertir URL de YouTube/Vimeo a embed
        let embedUrl = m.embed;
        if (embedUrl.includes('youtu')) {
          const vid = embedUrl.match(/(?:v=|youtu\.be\/)([^&?/]+)/)?.[1] || '';
          embedUrl = `https://www.youtube.com/embed/${vid}?autoplay=1`;
        } else if (embedUrl.includes('vimeo')) {
          const vid = embedUrl.match(/vimeo\.com\/(\d+)/)?.[1] || '';
          embedUrl = `https://player.vimeo.com/video/${vid}?autoplay=1`;
        }
        lbIframe.src = embedUrl;
        lbIframe.classList.add('is-active');
      } else {
        lbImg.src = m.src || '';
        lbImg.alt = m.alt || '';
        lbImg.classList.add('is-active');
      }

      // Contador
      counter.textContent = `${idx + 1} / ${mediaList.length}`;

      // Actualizar strip
      qs('.ppv2-lightbox__strip-thumb.is-active', lb)?.classList.remove('is-active');
      const stripThumb = qs(`[data-lb-idx="${idx}"]`, strip);
      if (stripThumb) {
        stripThumb.classList.add('is-active');
        stripThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function open(list, startIdx) {
      mediaList = list;
      // Construir strip
      strip.innerHTML = mediaList.map((m, i) =>
        `<div class="ppv2-lightbox__strip-thumb" data-lb-idx="${i}" tabindex="0" aria-label="Imagen ${i+1}">
           <img src="${m.src || ''}" alt="${m.alt || ''}" loading="lazy"/>
         </div>`
      ).join('');
      qsa('.ppv2-lightbox__strip-thumb', strip).forEach((t, i) => {
        t.addEventListener('click', () => showMedia(i));
      });
      showMedia(startIdx || 0);
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      lbVid.pause?.(); lbVid.src = '';
      lbIframe.src = '';
    }

    // Zoom en imagen
    lbImg.addEventListener('click', () => {
      if (!lbImg.classList.contains('is-active')) return;
      zoomed = !zoomed;
      lbImg.classList.toggle('is-zoomed', zoomed);
    });

    closeB.addEventListener('click', close);
    lb.addEventListener('click', e => { if (e.target === lb) close(); });
    prevB.addEventListener('click', () => showMedia(idx - 1));
    nextB.addEventListener('click', () => showMedia(idx + 1));

    // Swipe
    lb.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 44) showMedia(idx + (dx < 0 ? 1 : -1));
    });

    // Teclado
    document.addEventListener('keydown', e => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape')     close();
      if (e.key === 'ArrowLeft')  showMedia(idx - 1);
      if (e.key === 'ArrowRight') showMedia(idx + 1);
    });

    return { open, close };
  }

  /* ================================================================
     VARIANTES
  ================================================================ */
  function initVariants(container) {
    const form       = qs('.ppv2-form', container);
    const varInput   = qs('[name="id"]', form);
    if (!form || !varInput) return null;

    const optBtns = qsa('.ppv2-opt-btn', form);
    const qtyInput = qs('.ppv2-qty__input', container);

    let selectedOptions = {};
    let variants = [];

    try {
      const raw = container.dataset.variants;
      if (raw) variants = JSON.parse(raw);
    } catch(e) {}

    function findVariant() {
      if (!variants.length) return null;
      const keys = Object.keys(selectedOptions);
      return variants.find(v =>
        keys.every((k, i) => v[`option${i+1}`] === selectedOptions[k])
      );
    }

    function updatePrice(variant) {
      const priceEl   = qs('.ppv2-price__current', container);
      const compareEl = qs('.ppv2-price__compare', container);
      const badgeEl   = qs('.ppv2-price__badge', container);

      if (!variant || !priceEl) return;

      priceEl.textContent = formatMoney(variant.price);

      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (badgeEl && variant.compare_at_price > variant.price) {
        const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        badgeEl.textContent = `-${pct}%`;
        badgeEl.style.display = '';
      }
    }

    function updateAvailability(variant) {
      const avEl = qs('.ppv2-availability', container);
      if (!avEl || !variant) return;
      avEl.className = `ppv2-availability ppv2-availability--${variant.available ? 'in' : 'out'}`;
      const dot = qs('.ppv2-availability__dot', avEl);
      const txt = qs('.ppv2-availability__text', avEl);
      if (txt) txt.textContent = variant.available ? '¡Disponible! Listo para enviar' : 'Agotado';
    }

    optBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const option = btn.dataset.option;
        const value  = btn.dataset.value;
        selectedOptions[option] = value;

        // Actualizar activo por grupo
        qsa(`.ppv2-opt-btn[data-option="${option}"]`, form).forEach(b => {
          b.classList.toggle('is-active', b.dataset.value === value);
        });

        const variant = findVariant();
        if (variant) {
          varInput.value = variant.id;
          updatePrice(variant);
          updateAvailability(variant);

          // Actualizar sticky bar
          const sbPrice = qs('.ppv2-sticky-bar__price');
          if (sbPrice) sbPrice.textContent = formatMoney(variant.price);
          const mbPrice = qs('.ppv2-mobile-bar__price');
          if (mbPrice) mbPrice.textContent = formatMoney(variant.price);
        }
      });
    });

    // Activar primera variante disponible
    const firstAvail = variants.find(v => v.available) || variants[0];
    if (firstAvail) {
      varInput.value = firstAvail.id;
      updatePrice(firstAvail);
    }

    function getVariantId() { return parseInt(varInput.value, 10); }
    function getQty() { return parseInt(qtyInput?.value || '1', 10); }

    return { getVariantId, getQty };
  }

  /* ================================================================
     CANTIDAD
  ================================================================ */
  function initQty(container) {
    qsa('.ppv2-qty', container).forEach(wrap => {
      const input   = qs('.ppv2-qty__input', wrap);
      const minusBtn = qs('[data-qty-minus]', wrap);
      const plusBtn  = qs('[data-qty-plus]', wrap);

      if (!input) return;

      if (minusBtn) minusBtn.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change'));
      });

      if (plusBtn) plusBtn.addEventListener('click', () => {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ================================================================
     STICKY BAR
  ================================================================ */
  function initStickyBar() {
    const bar      = qs('.ppv2-sticky-bar');
    const mob      = qs('.ppv2-mobile-bar');
    const closeBtn = qs('#Ppv2StickyClose');
    if (!bar && !mob) return;

    const threshold = 400;
    let dismissed   = false;
    let ticking     = false;
    let shown       = false;

    // Reposicionar el botón X a la esquina superior derecha
    if (closeBtn) {
      closeBtn.style.cssText = 'position:absolute!important;top:-10px!important;right:-10px!important;left:auto!important;';
    }

    function showBar() {
      if (shown || dismissed) return;
      shown = true;
      bar.style.setProperty('transform', 'translateY(0)', 'important');
      bar.style.setProperty('opacity', '1', 'important');
      bar.classList.add('is-visible');
    }

    function hideBar() {
      if (!shown) return;
      shown = false;
      bar.style.setProperty('transform', 'translateY(160px)', 'important');
      bar.style.setProperty('opacity', '0', 'important');
      bar.classList.remove('is-visible');
    }

    function dismissBar() {
      dismissed = true;
      hideBar();
      setTimeout(() => {
        bar.style.setProperty('pointer-events', 'none', 'important');
        bar.classList.add('is-dismissed');
      }, 420);
    }

    // Ajustar posición en mobile
    function adjustMobile() {
      if (window.innerWidth <= 749) {
        bar.style.setProperty('left', '16px', 'important');
        bar.style.setProperty('bottom', '80px', 'important');
        bar.style.setProperty('width', 'calc(100vw - 32px)', 'important');
        bar.style.setProperty('max-width', '340px', 'important');
      } else {
        bar.style.setProperty('left', '24px', 'important');
        bar.style.setProperty('bottom', '24px', 'important');
        bar.style.setProperty('width', '300px', 'important');
        bar.style.setProperty('max-width', '', 'important');
      }
    }

    // ── Botón X: cierra el popup para toda la sesión ──────
    if (closeBtn) {
      closeBtn.addEventListener('click', e => {
        e.stopPropagation();
        dismissBar();
      });
    }

    function update() {
      const y = window.scrollY;
      if (bar && !dismissed) {
        if (y > threshold) showBar();
        else hideBar();
      }
      if (mob) mob.classList.toggle('is-visible', y > threshold);
      ticking = false;
    }

    adjustMobile();
    window.addEventListener('resize', adjustMobile, { passive: true });
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ================================================================
     BARRA DE ESCASEZ
  ================================================================ */
  function initScarcityBar() {
    qsa('.ppv2-scarcity').forEach(bar => {
      const fill = qs('.ppv2-scarcity__fill', bar);
      if (!fill) return;
      const pct = parseFloat(fill.dataset.pct || '0');
      // Animar al entrar en viewport
      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            setTimeout(() => { fill.style.width = pct + '%'; }, 150);
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.3 });
      obs.observe(bar);
    });
  }

  /* ================================================================
     TABS
  ================================================================ */
  function initTabs(container) {
    const navBtns = qsa('.ppv2-tab-btn', container);
    const panels  = qsa('.ppv2-tab-panel', container);

    navBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        navBtns.forEach(b => b.classList.toggle('is-active', b === btn));
        panels.forEach(p => p.classList.toggle('is-active', p.dataset.tab === target));
      });
    });
  }

  /* ================================================================
     FAQ ACORDEÓN
  ================================================================ */
  function initFaq(container) {
    qsa('.ppv2-faq__trigger', container).forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.ppv2-faq__item');
        const isOpen = item.classList.contains('is-open');
        qsa('.ppv2-faq__item', container).forEach(i => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ================================================================
     ANIMACIONES AL SCROLL
  ================================================================ */
  function initScrollAnimations() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    qsa('.ppv2-anim').forEach(el => obs.observe(el));
  }

  /* ================================================================
     BLOQUES RELATED_PRODUCTS DENTRO DE PPV2-MAIN
     Paginación, variantes, cantidad, ajax add-to-cart
  ================================================================ */
  function initPpvRelBlocks(scope) {
    const blocks = qsa('.ppv2-rel', scope || document);
    if (!blocks.length) return;

    blocks.forEach(block => {
      if (block._ppvRelInit) return;   // evitar doble init
      block._ppvRelInit = true;

      const ipp      = parseInt(block.dataset.itemsPerPage || '3', 10);
      const cards    = qsa('.ppv2-rel__card', block);
      const prevBtn  = qs('.ppv2-rel__nav-btn--prev', block);
      const nextBtn  = qs('.ppv2-rel__nav-btn--next', block);

      /* Paginación */
      let page = 0;
      const totalPages = Math.ceil(cards.length / ipp);

      function showPage(p) {
        page = Math.max(0, Math.min(p, totalPages - 1));
        cards.forEach((c, i) => {
          c.style.display = (i >= page * ipp && i < (page + 1) * ipp) ? '' : 'none';
        });
        if (prevBtn) prevBtn.disabled = page === 0;
        if (nextBtn) nextBtn.disabled = page >= totalPages - 1;
      }
      showPage(0);
      prevBtn?.addEventListener('click', () => showPage(page - 1));
      nextBtn?.addEventListener('click', () => showPage(page + 1));

      /* Variantes */
      qsa('[data-ppvrel-select]', block).forEach(sel => {
        const card = sel.closest('.ppv2-rel__card');
        sel.addEventListener('change', () => {
          const opt = sel.options[sel.selectedIndex];
          card.dataset.variantId = sel.value;
          const priceEl = qs('.ppv2-rel__card-price-now', card);
          const cmpEl   = qs('.ppv2-rel__card-price-was', card);
          if (priceEl && opt.dataset.price) {
            priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10));
          }
          if (cmpEl) {
            const cmp = parseInt(opt.dataset.compare || '0', 10);
            const pr  = parseInt(opt.dataset.price   || '0', 10);
            cmpEl.style.display = cmp > pr ? '' : 'none';
            if (cmp > pr) cmpEl.textContent = formatMoney(cmp);
          }
        });
      });

      /* Cantidad */
      cards.forEach(card => {
        const input = qs('[data-ppvrel-qty]',   card);
        const minus = qs('[data-ppvrel-minus]', card);
        const plus  = qs('[data-ppvrel-plus]',  card);
        if (!input) return;
        minus?.addEventListener('click', () => {
          input.value = Math.max(1, parseInt(input.value, 10) - 1);
        });
        plus?.addEventListener('click', () => {
          input.value = parseInt(input.value, 10) + 1;
        });
      });

      /* Agregar al carrito */
      qsa('[data-ppvrel-add]', block).forEach(btn => {
        btn.addEventListener('click', () => {
          const card  = btn.closest('.ppv2-rel__card');
          const varId = parseInt(card.dataset.variantId, 10);
          const qty   = parseInt(qs('[data-ppvrel-qty]', card)?.value || '1', 10);
          addToCartRelated(varId, qty, btn, 'ppv2-rel__card-btn');
        });
      });
    });
  }

  /* ================================================================
     INICIALIZACIÓN PRINCIPAL
  ================================================================ */
  function formatMoney(cents) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(cents / 100);
  }

  function initProduct() {
    const container = qs('.ppv2');
    if (!container) return;

    // Galería premium + lightbox
    const gallery = initGallery(container);
    const lb      = initLightbox();

    // Abrir lightbox al hacer clic en el botón zoom de cada item (desktop + mobile)
    qsa('.ppv2-gallery__zoom-btn', container).forEach((btn, i) => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        if (!gallery) return;
        const list = gallery.getMediaData();
        lb.open(list, i);
      });
    });

    // Clic sobre la imagen:
    //   Desktop → abre lightbox
    //   Mobile  → solo cambia la imagen activa (sin abrir lightbox)
    const isMobile = gallery?.isMobile || (() => window.innerWidth <= 989);

    qsa('.ppv2-gallery__item', container).forEach((item, i) => {
      item.addEventListener('click', e => {
        // Ignorar si fue en overlay de play o botón zoom
        if (e.target.closest('.ppv2-gallery__play-overlay') ||
            e.target.closest('.ppv2-gallery__zoom-btn')) return;

        if (item.dataset.type !== 'image') return;

        if (isMobile()) {
          // Mobile: solo activar la imagen elegida
          e.preventDefault();
          e.stopPropagation();
          gallery?.activate(i, false);
        } else {
          // Desktop: abrir lightbox
          if (gallery) lb.open(gallery.getMediaData(), i);
        }
      });
    });

    // ── Bloques related_products dentro de ppv2-main ───────────
    initPpvRelBlocks(container);

    // Variantes
    const varCtrl = initVariants(container);

    // Cantidad
    initQty(container);

    // ── Función helper: leer qty actual del DOM siempre fresh ──
    function getCurrentQty() {
      const input = qs('.ppv2-qty__input', container);
      return parseInt(input?.value || '1', 10) || 1;
    }
    function getCurrentVariantId() {
      return varCtrl?.getVariantId() || parseInt(container.dataset.variantId, 10);
    }

    // Botones de carrito (dentro del container)
    qsa('.ppv2-btn--cart, .ppv2-sticky-bar__btn--cart, .ppv2-mobile-bar__btn--cart', container).forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        addToCart(getCurrentVariantId(), getCurrentQty(), btn);
      });
    });

    // También desde sticky/mobile bar (fuera del container)
    qsa('.ppv2-sticky-bar__btn--cart, .ppv2-mobile-bar__btn--cart').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        addToCart(getCurrentVariantId(), getCurrentQty(), btn);
      });
    });

    // Botón comprar ahora
    qsa('.ppv2-btn--buy, .ppv2-sticky-bar__btn--buy, .ppv2-mobile-bar__btn--buy').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        buyNow(getCurrentVariantId(), getCurrentQty(), btn);
      });
    });

    // Sticky bar
    initStickyBar();
    initScarcityBar();
    initScrollAnimations();

    // Tabs
    qsa('[data-ppv2-tabs]').forEach(t => initTabs(t));

    // FAQ
    qsa('.ppv2-faq').forEach(f => initFaq(f));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProduct);
  } else {
    initProduct();
  }

  // Hot reload del editor
  document.addEventListener('shopify:section:load', e => {
    initProduct();
    // Re-iniciar bloques related que puedan estar en la sección recargada
    initPpvRelBlocks(e.target);
  });

  // ── Inicialización desde Quick View (catalogo-dibai.js dispara este evento) ──
  document.addEventListener('dibai:initGallery', function(e) {
    var container = e.detail && e.detail.container;
    if (!container) return;
    // Buscar el ppv2 padre para usar como container de la galería
    var ppv2Container = container.closest('.ppv2') || container;
    initGallery(container);
    // Conectar lightbox si existe
    var lb = initLightbox();
    qsa('.ppv2-gallery__zoom-btn', ppv2Container).forEach(function(btn, i) {
      btn.addEventListener('click', function(ev) {
        ev.stopPropagation();
        if (lb) lb.open(i);
      });
    });
  });

})();


// ── Acordeón Especificaciones ─────────────────────────────────────────────────
(function initSpecsAccordion() {
  function setup(trigger) {
    var bodyId = trigger.getAttribute('aria-controls');
    var body   = document.getElementById(bodyId);
    if (!body) return;

    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        body.setAttribute('hidden', '');
      } else {
        body.removeAttribute('hidden');
      }
    });
  }

  function init() {
    document.querySelectorAll('.ppv2-specs-accordion__trigger').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor reload
  document.addEventListener('shopify:section:load', init);
})();
